import React, {
  useEffect, useState, useRef, ChangeEvent, FocusEvent, FormEvent,
} from 'react';
// import { EyeCon } from '@fff-web/fff-ui-shared/Icon';
import classNames from 'classnames';
import useValidation from './hooks/useValidationHook';
import PasswordToolTip from './PasswordTooltip';
import InputProps from './props/inputProps';
import styles from './scss/Input.module.scss';
import InputError from './InputError';
import { trackFormInput } from '../../utils/segment/events';
import { PERSONAL_INFO_INPUT_FIELD } from '../../utils/segment/constants';

// TO DO: reimplement the show password button
// it is currently not behaving consistently, sometimes doesn't work and changes position
const PasswordInput: React.FunctionComponent<InputProps> = (props: InputProps) => {
  const {
    name,
    label,
    autoComplete,
    maxLength,
    placeholder,
    hasMargin,
    handleInput,
    value,
    errorMessage,
    focus,
  } = props;

  const inputRef = useRef<HTMLInputElement>(null);
  const [showPasswordToolTip, setShowPasswordToolTip] = useState(false);
  const {
    isInvalid, validationClass, handleValidationChange, handleValidationBlur,
  } = useValidation();

  // const handleShowPassword = () => {
  //   setShowPassword(!showPassword);
  // };

  function togglePasswordTooltip(showToolTip: boolean) {
    if (name === 'password') {
      setShowPasswordToolTip(showToolTip);
    }
  }

  const setFocusOnPasswordInput = () => inputRef?.current?.focus();

  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (handleInput) {
      handleInput(e);
    }
    handleValidationChange(name, e.target.value);
  };

  const handleOnBlur = (e: FocusEvent<HTMLInputElement>) => {
    togglePasswordTooltip(false);
    handleValidationBlur(name, e.target.value);
    trackFormInput(PERSONAL_INFO_INPUT_FIELD);
  };

  const handleOnInput = (e: FormEvent<HTMLInputElement>) => {
    const autofillValue = (e.target as HTMLInputElement).value;
    handleValidationBlur(name, autofillValue);
    if (handleInput) {
      const input = { target: { name, value: autofillValue } };
      handleInput(input);
    }
    // Should we fire segment event for autofill here?
  };

  useEffect(() => {
    if (focus && inputRef) setFocusOnPasswordInput();
  }, [focus, inputRef]);

  return (
    <div className={classNames(styles.inputContainer,
      { [styles.inputContainerMargin]: hasMargin })}
    >
      { showPasswordToolTip && <PasswordToolTip password={value} /> }
      <label htmlFor={name} className={styles.label}>
        {label}
        <input
          id="password"
          data-testid="password"
          name={name}
          className={classNames(styles.input, validationClass)}
          // type={showPassword ? 'text' : 'password'}
          type="password"
          ref={inputRef}
          onChange={handleOnChange}
          onBlur={handleOnBlur}
          onInput={handleOnInput}
          value={value}
          placeholder={placeholder}
          autoComplete={autoComplete}
          maxLength={maxLength}
          onFocus={() => togglePasswordTooltip(true)}
        />
        {isInvalid && !showPasswordToolTip && <InputError errorMessage={errorMessage} />}
        {/* <div
          className={styles.passwordReveal}
          tabIndex={0}
          onClick={handleShowPassword}
          onKeyPress={handleShowPassword}
          role="button"
        >
          <EyeCon />
        </div> */}
      </label>
    </div>
  );
};

PasswordInput.defaultProps = {
  disabled: false,
  focus: false,
};

export default PasswordInput;
